import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function MovieRecommendations() {
  return (
    <section className="bg-background-100/70 border-y border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">最新影视推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">精选“泰坦尼克号”主题电影、剧集与纪录片</p>
          </div>
          <Link to="/category" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
            更多作品 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {movies.slice(0, 6).map((movie) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={movie.cover}
                  alt={`${movie.title}（${movie.year}）封面`}
                  title={`${movie.title} 泰坦尼克号`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-900/80 text-background-50 text-xs">
                  {movie.type}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-primary-950 text-xs font-semibold flex items-center gap-1">
                  <i className="ri-star-fill"></i>
                  {movie.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 mb-1.5 line-clamp-1">{movie.title}</h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{movie.cast.join(' / ')}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{movie.year}</span>
                  <span className="flex flex-wrap gap-1">
                    {movie.tags.slice(0, 2).map((t) => (
                      <span key={t} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800">
                        {t}
                      </span>
                    ))}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}